import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  HostListener,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import _ from 'lodash';
import { Store, select } from '@ngrx/store';
import * as fromApp from '../../shared/store/app.reducer';
import * as LmsActions from './store/lms-activities.actions';
import { ActivatedRoute, NavigationStart } from '@angular/router';
import { AppConfig } from '../../config/app-config';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-lms-activities-process-flow',
  templateUrl: './lms-activities-process-flow.component.html',
  styleUrls: ['./lms-activities-process-flow.component.css'],
})
export class LmsActivitiesProcessFlowComponent implements OnInit {
  CAP_CONTACT_URL: string;

  E_STORE_URL: string;

  LEARNING_HOME: string;

  ACTIVITY_DETAILS_TEMPLATE = '';

  readonly SELECT_LAB_TEXT = 'Select a Laboratory/Organization';

  hasLabAffiliation = true;

  kitsAvailable = true;

  dataFromLmsService;

  labSelect: FormGroup;

  showLabSelect = false;

  labsHavingKits = [];

  headline: string;

  enterCap = false;

  invalidCap = false;

  emptyCap = false;

  showConfirmation = false;

  affiliationSuccess = false;

  allKitsUsed = false;

  cecityActivityId: any;

  activity;

  kits = [];

  labInfo: any;

  numAssignedKits: number;

  submitFormText;

  formCreated = false;

  showEnterCapTooltip = false;

  firstAndLastName: string;

  showErrorModal: boolean;

  isLoading: boolean;

  kitsFulfilled: boolean;

  orgFullName: string;

  orgFullAddress: string;

  validCapSize = true;
  qMedActivityNotAvailable = false;

  readonly ENTER_CAP_TEXT = 'Enter Laboratory/Organization CAP #';

  constructor(
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.params.subscribe(
      (params) => (this.cecityActivityId = params.activityCode)
    );
    this.CAP_CONTACT_URL = AppConfig.settings.capContactUrl;
    this.E_STORE_URL = AppConfig.settings.estore;
    this.LEARNING_HOME = AppConfig.settings.cecity.home;
    this.ACTIVITY_DETAILS_TEMPLATE =
      AppConfig.settings.cecity.cecityActivityDetails;
    // this.ACTIVITY_DETAILS_TEMPLATE = this.E_STORE_URL.replace(
    //   '{cecityActivityId}',
    //   this.cecityActivityId
    // );

    this.store.select('auth').subscribe((authState) => {
      this.firstAndLastName = authState.userInfo
        ? `${authState.userInfo.firstName} ${authState.userInfo.lastName}`
        : '';
      this.showErrorModal = authState.showErrorModal;
      this.isLoading = authState.isLoading;
      if (authState.userInfo) {
        this.E_STORE_URL = this.E_STORE_URL.replace(
          '{partyNumber}',
          authState.userInfo.userCapNumber
        );
      }
    });

    this.store.pipe(select((state: any) => state.lms)).subscribe((lmsState) => {
      this.showLabSelect = lmsState.showLabSelect;
      this.headline = lmsState.headline;
      this.hasLabAffiliation = lmsState.hasLabAffiliation;
      this.labsHavingKits = lmsState.labsHavingKits;
      this.enterCap = lmsState.enterCap;
      this.kitsAvailable = lmsState.kitsAvailable;
      this.dataFromLmsService = lmsState.dataFromLmsService;
      this.labInfo = lmsState.labInfo;
      this.showConfirmation = lmsState.showConfirmation;
      this.affiliationSuccess = lmsState.affiliationSuccess;
      this.kits = lmsState.kits;
      this.numAssignedKits = lmsState.numAssignedKits;
      this.activity = lmsState.activity;
      this.allKitsUsed =
        lmsState.allKitsUsed ||
        (this.kits.length > 0 && this.labsHavingKits.length === 0);
      this.kitsFulfilled = lmsState.kitsFulfilled;
      this.invalidCap =
        lmsState.invalidCap || !this.validCapSize ? true : false;

      if (this.activity.lmsActivityId) {
        this.E_STORE_URL = this.E_STORE_URL.replace(
          '{activityCode}',
          this.activity.activityCode
        );
      }

      if (
        lmsState.assignmentStatus === 'S_ASSIGNED' ||
        lmsState.assignmentStatus === 'E_KIT_WAS_ALREADY_ASSIGNED_TO_THIS_USER'
      ) {
        window.location.href =
          this.ACTIVITY_DETAILS_TEMPLATE.replace(
            '{cecityActivityId}',
            this.cecityActivityId.toString()
          ) + '/takecourse';
      }

      if (this.enterCap) {
        this.submitFormText = 'Continue';
      } else {
        this.submitFormText = 'Complete Activity Registration';
      }

      if (!this.formCreated && this.dataFromLmsService) {
        this.createForm();
        this.formCreated = true;
      }

      if (this.labInfo.orgName !== undefined) {
        this.orgFullName =
          this.labInfo.orgName +
          (this.labInfo.lbn2 != null ? ', ' + this.labInfo.lbn2 : '');
        this.orgFullAddress =
          this.labInfo.address1 +
          (this.labInfo.address2 != null ? ', ' + this.labInfo.address2 : '') +
          (this.labInfo.address3 != null ? ', ' + this.labInfo.address3 : '') +
          (this.labInfo.address4 != null ? ', ' + this.labInfo.address4 : '');
        console.log(
          'this.orgFullName....',
          this.orgFullName,
          'address....',
          this.orgFullAddress
        );
      }
    });
    this.store.dispatch(new LmsActions.GetLabSelectData(this.cecityActivityId));
  }

 private createForm() {
  // default sorting on init
  this.labsHavingKits = [...this.labsHavingKits].sort(
    (a, b) => Number(a.capNumber) - Number(b.capNumber)
  );

  let labSelectDefault;

  if (this.labsHavingKits.length > 1) {
    labSelectDefault = this.SELECT_LAB_TEXT;
  } else if (_.isEmpty(this.labsHavingKits)) {
    labSelectDefault = this.ENTER_CAP_TEXT;
  } else if (this.labsHavingKits.length === 1) {
    labSelectDefault = this.labsHavingKits[0]; 
  }

  console.log("Final value of labSelectDefault:", labSelectDefault);

  this.labSelect = new FormGroup({
    lab: new FormControl(labSelectDefault, Validators.required),
    cap: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
      Validators.maxLength(7),
      Validators.minLength(7),
    ]),
  });

  this.labSelect.valueChanges.subscribe((v) => {
    console.log("console3", v);
    if (v.lab === this.ENTER_CAP_TEXT) {
      this.store.dispatch(new LmsActions.EnterCap());
    } else if (v.lab === this.SELECT_LAB_TEXT) {
    } else {
      this.store.dispatch(new LmsActions.SelectLabFromDropdown());
    }
  });
}

get sortedLabs() {
  return [...this.labsHavingKits].sort(
    (a, b) => Number(a.capNumber) - Number(b.capNumber)
  );
}


  continueToActivity() {
    if (this.validateFields()) {
       const selectedLab = this.labsHavingKits.find(l => l.capNumber === this.labSelect.value.lab.capNumber);
      if (this.enterCap && !this.affiliationSuccess) {
        this.validCapSize = true;
        this.getLabInfo();
      } else {
        if (this.enterCap) {
          this.store.dispatch(
            new LmsActions.AssignKitToUser(
              this.activity.lmsActivityId,
              this.labSelect.value.cap
            )
          );
        } else {
          const selectedLab = this.labsHavingKits.find(l => l.capNumber === this.labSelect.value.lab.capNumber);
          this.store.dispatch(
            new LmsActions.AssignKitToUser(
              this.activity.lmsActivityId,
              selectedLab.capNumber
            )
          );
        }
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }

  confirmAffiliation() {
    if (this.activity.processFlowType === '1:M/PURCHASE') {
      this.store.dispatch(
        new LmsActions.AffiliateUserToLabQmed(
          this.activity,
          this.labSelect.value.cap
        )
      );
    } else {
      this.store.dispatch(
        new LmsActions.AffiliateUserToLab(
          this.activity,
          this.labSelect.value.cap,
          this.activity.mailingCodesList[0]
        )
      );
    }
  }

  private getLabInfo() {
    this.store.dispatch(new LmsActions.GetLabInfo(this.labSelect.value.cap));
  }

  private validateFields() {
    if (!this.labSelect.controls.cap.valid && this.enterCap) {
      // Determine if the CAP number is empty, or just simply invalid
      if (_.isNil(this.labSelect.value.cap)) {
        this.emptyCap = true;
      } else {
        this.invalidCap = true;
        this.validCapSize = false;
      }
    } else {
      this.invalidCap = false;
      this.emptyCap = false;
    }

    if (this.emptyCap || this.invalidCap) {
      return false;
    }
    return true;
  }

  closeConfirmation() {
    this.store.dispatch(new LmsActions.CloseConfirmation());
  }

  closeErrorDialog() {
    this.showErrorModal = false;
  }

  toggleTooltip(event: Event, kind: string) {
    event.stopPropagation();
    switch (kind) {
      case 'ENTER_CAP':
        this.showEnterCapTooltip = !this.showEnterCapTooltip;
        break;
      default:
        this.showEnterCapTooltip = false;
    }
  }
  purchaseForIndvUse() {
    if (
      this.activity.activityCode.split('.')[1] ==
      new Date().getFullYear() - 1
    ) {
      this.qMedActivityNotAvailable = true;
    } else {
      window.location.href = this.E_STORE_URL;
    }
  }
//   purchaseForIndvUse() {
//   const activityCodeParts = this.activity.activityCode.split('.');
//   const activityYear = parseInt(activityCodeParts[1], 10);
//   const lastYear = new Date().getFullYear() - 1;

//   if (activityYear === lastYear) {
//     this.qMedActivityNotAvailable = true;
//   } else {
//     window.location.href = this.E_STORE_URL;
//   }
// }

  purchaseNewProgramVersion() {
    const nextActivityYear =
      parseInt(this.activity.activityCode.split('.')[1], 10) + 1;
    const nextYearActivityCode = `${
      this.activity.activityCode.split('.')[0]
    }.${nextActivityYear}`;
    console.log('nextYearActivityCode.....', nextYearActivityCode);
    const actualUrl = this.E_STORE_URL.replace(
      this.activity.activityCode,
      nextYearActivityCode
    );
    console.log('actualUrl........', actualUrl);
    window.location.href = actualUrl;
  }
}
